import { AVATAR_TONE } from './types'
import type { ActivityHistoryUser, AvatarTone } from './types'

export const MISSING_ACTOR = '—'

export interface ActorDisplay {
  name: string
  initials: string
  tone: AvatarTone | undefined
  fallbackId: string | undefined
}

export function getActorDisplay(user: ActivityHistoryUser): ActorDisplay {
  const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim()
  if (!name) {
    return {
      name: MISSING_ACTOR,
      initials: MISSING_ACTOR,
      tone: AVATAR_TONE.gray,
      fallbackId: undefined,
    }
  }
  const initials =
    `${user.firstName.at(0) ?? ''}${user.lastName.at(0) ?? ''}`.toUpperCase()
  return { name, initials, tone: user.tone, fallbackId: user.id }
}
